import { setAlert } from '../../alert';
import { getConfig, getFormDataConfig } from '../constants/00-base-constants';
import {
    GET_WASTE_TO_LANDFILL_DATA_SUCCESS,
    GET_WASTE_TO_LANDFILL_DATA_FAIL,
    POST_WASTE_TO_LANDFILL_DATA_SUCCESS,
    POST_WASTE_TO_LANDFILL_DATA_FAIL,
    GET_WASTE_TO_LANDFILL_DATA_TOTALS_SUCCESS,
    GET_WASTE_TO_LANDFILL_DATA_TOTALS_FAIL
} from '../types/05-indirect-ghg-emissions-from-other-sources';
import {
    GET_WASTE_TO_LANDFILL_DATA,
    POST_WASTE_TO_LANDFILL_DATA,
    GET_WASTE_TO_LANDFILL_DATA_TOTALS
} from '../constants/05-indirect-ghg-emissions-from-other-sources';
import api from '../../../util/api';

export const postWasteToLandfillData = (formData, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + POST_WASTE_TO_LANDFILL_DATA + `/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            getFormDataConfig()
        );
        dispatch({
            type: POST_WASTE_TO_LANDFILL_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_WASTE_TO_LANDFILL_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getWasteToLandfillData = (year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + GET_WASTE_TO_LANDFILL_DATA + `/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            getConfig()
        );
        dispatch({
            type: GET_WASTE_TO_LANDFILL_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_WASTE_TO_LANDFILL_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getWasteToLandfillDataTotals = (year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + GET_WASTE_TO_LANDFILL_DATA_TOTALS + `/${year}/${facility}`,
            getConfig()
        );
        dispatch({
            type: GET_WASTE_TO_LANDFILL_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_WASTE_TO_LANDFILL_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};
